import React, { useState, FC, useEffect, useRef } from "react";
import TextField, { TextFieldProps } from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import AccountCircle from "@mui/icons-material/AccountCircle";
import SearchIcon from "@mui/icons-material/Search";
import { IconButton, useTheme } from "@mui/material";
import { useRecoilState } from "recoil";
import { userState } from "../../../../states/userState";
import { setUserToLocalStorage } from "../../../../functions/localStorageManager";
import {
  backgroundColor,
  foreColor,
  foreColorOnMouseOver,
} from "../../../../commons/colors";
import { User } from "../../../types/user";

type Props = {
  fullWidth: boolean;
  label: string;
  multiline: boolean;
  required: boolean;
  rows: number;
  type: string;
  InputProps?: TextFieldProps["InputProps"];
  placeholder: string;
  disabled: boolean;
  productNo: string;
  setProductNo: React.Dispatch<React.SetStateAction<string>>;
  productBno: string;
  setProductBno: React.Dispatch<React.SetStateAction<string>>;
  toggleFocus: boolean;
  fetchProcess: (
    aProductNo?: string,
    aProductBno?: string,
    aSalesNo?: string
  ) => Promise<void>;
};
const TextInputForproductBno: FC<Props> = (props) => {
  const {
    productNo,
    setProductNo,
    productBno,
    setProductBno,
    toggleFocus,
    fetchProcess,
  } = props;
  const [user, setUser] = useRecoilState(userState);
  const textFieldRef = useRef<HTMLDivElement>(null);

  const theme = useTheme();

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const regex = /^\d{0,2}$/; // 最大2桁の数字のみを許可する正規表現

    if (regex.test(value)) {
      setProductBno(value);
    }
  };
  const handleOnFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    setProductBno("");
    let setString = productNo;
    if (productNo.includes("-")) {
      setString = productNo.replace("-", "");
    }
    setUser((prevUser: User) => {
      // const newUser: User = { ...prevUser, isAuth: true };
      // デフォルト値を設定
      // const defaultInitialParams: InitialParameters = {
      //   workersForInput: [],
      //   workersForList: [],
      //   factoryNo: [],
      //   productBno: "",
      //   productBno: "",
      //   latestUrl: "",
      // };
      const newUser: User = {
        ...prevUser,
        filters: {
          // ...defaultInitialParams,
          ...prevUser.filters,
          productNo: setString,
        },
      };
      //LocalStorageにユーザ情報をセット
      setUserToLocalStorage(newUser);
      return newUser;
    });
  };
  const handleOnBlur = () => {
    let setString = user.filters.productNo;

    if (productBno.length > 0) {
      setProductBno((prevState) => {
        const newState =
          prevState.length < 2 ? String(prevState).padStart(2, "0") : prevState;
        return newState;
      });
      let setString = user.filters.productNo;
      if (user.filters.productNo.includes("-")) {
        if (productBno.length < 2) {
          setString = productNo + "-" + String(productBno).padStart(2, "0");
        } else {
          setString = productNo + "-" + productBno;
        }
      } else {
        if (productBno.length < 2) {
          setString = productNo + "-" + String(productBno).padStart(2, "0");
        } else {
          setString = productNo + "-" + productBno;
        }
      }
      setUser((prevUser: User) => {
        const newUser: User = {
          ...prevUser,
          filters: {
            // ...defaultInitialParams,
            ...prevUser.filters,
            productNo: setString,
          },
        };
        //LocalStorageにユーザ情報をセット
        setUserToLocalStorage(newUser);
        return newUser;
      });
    }

    // console.log("productBno", productBno);
    // if (user.filters.productNo.includes("-")) {
    //   if (productBno.length > 0) {

    //   } else {
    //     setString = setString.replace("-", "");
    //   }
    // } else {
    //   if (productBno.length > 0) {
    //     setProductBno((prevState) => {
    //       const newState = String(prevState).padStart(2, "0");
    //       setString = productNo + "-" + newState;
    //       return newState;
    //     });
    //   } else {
    //     setString = setString.replace("-", "");
    //   }
    // }
    // console.log("productBno", productBno, "setString", setString);
    // setUser((prevUser: User) => {
    //   const newUser: User = {
    //     ...prevUser,
    //     filters: {
    //       // ...defaultInitialParams,
    //       ...prevUser.filters,
    //       productNo: setString,
    //     },
    //   };
    //   //LocalStorageにユーザ情報をセット
    //   setUserToLocalStorage(newUser);
    //   return newUser;
    // });
  };
  const handleKeyDown = async (e: any) => {
    if (e.key === "Enter") {
      e.target.blur();
      let setString =
        String(e.target.value).length > 0
          ? String(e.target.value).padStart(2, "0")
          : "";
      await fetchProcess(
        user.filters.productNo.split("-")[0],
        setString,
        user.filters.salesNo
      );
    }
  };
  useEffect(() => {
    if (productNo.length === 8 && toggleFocus) {
      textFieldRef.current?.focus();
    }
    // if (productNo.length === 0) {
    //   setProductBno("");
    // }
  }, [productNo]);
  return (
    <TextField
      inputRef={textFieldRef} // refをTextFieldに紐づける
      // color={"#0adcc0"}
      variant="standard"
      fullWidth={props.fullWidth}
      label={props.label}
      InputLabelProps={{ shrink: true }}
      margin="dense"
      multiline={props.multiline}
      required={props.required}
      rows={props.rows}
      value={productBno}
      type={props.type}
      onChange={handleOnChange}
      onFocus={handleOnFocus}
      onBlur={handleOnBlur}
      onKeyDown={handleKeyDown}
      disabled={props.disabled}
      placeholder={props.placeholder}
      InputProps={{
        ...props.InputProps,
        endAdornment: props.InputProps ? (
          // <InputAdornment position="start">
          //   <div
          //     style={{
          //       backgroundColor: "#0adcc0",
          //       width: "36px",
          //       height: "20px",
          //       paddingLeft: "6px",
          //       borderRadius: "5px",
          //       cursor: "pointer",
          //     }}
          //     onClick={props.onClick}
          //   >
          //     <SearchIcon />
          //   </div>
          // </InputAdornment>
          <></>
        ) : null,
        sx: {
          "& .MuiInput-underline:before": {
            borderBottomColor: foreColor(user?.mode ?? "lite"), // 通常時の下線の色
          },
          "& .MuiInput-underline:after": {
            borderBottomColor: foreColor(user?.mode ?? "lite"), // フォーカス時の下線の色
          },
          "& .MuiInput-underline:hover:before": {
            borderBottomColor: `${foreColor(user?.mode ?? "lite")}!important`, // ホバー時の下線の色
          },
          "& .MuiInput-underline": {
            borderBottomColor: `${foreColor(user?.mode ?? "lite")}!important`, // ホバー時の下線の色
          },
          // 他のスタイルもここに追加できます
        },
      }}
      sx={{
        margin: "20px 0",

        "&&&": {
          // color: "blue",
          width: "45px",
          height: "42px",
          backgroundColor: backgroundColor(user?.mode ?? "lite"),
          padding: "5px 10px 2px 10px",
          borderRadius: "5px",
        },
        "& label": {
          padding: "10px",
          color: foreColor(user?.mode ?? "lite"),
          fontSize: "18px",
        },
        "& svg": {
          // marginTop: "5px",
          color: "#f0f2f5",
        },
        "& input": {
          paddingTop: 0,
          paddingBottom: 0,
          marginTop: "5px",
          paddingLeft: "2px",
          fontSize: "16px",
          color: foreColor(user?.mode ?? "lite"),
          fontWeight: "700",
          "&:hover": {
            color: foreColor(user?.mode ?? "lite"),
          },
          "&:focus": {
            color: foreColor(user?.mode ?? "lite"),
          },
          //   backgroundColor: "black",
        },
        "& .MuiSvgIcon-root": {
          color: "#f0f2f5",
        },
        "& .MuiInputBase-input": {
          fontSize: "16px",
          color: foreColor(user?.mode ?? "lite"),
          fontWeight: "700",
        },
        // InputPropsで指定したスタイル以外にもここで追加できます
      }}
    />
  );
};
export default TextInputForproductBno;
